<template>
  <div class="main-layout">
    <div class="main pvp-container">
      <slot/>
      <transition
        v-if="!appIsSmall"
        name="fade">
        <div
          v-if="scrollTopVisible"
          class="scroll-top-button fade-animation"
          @click="scrollToTop">
          <div class="scroll-top-text">
            <app-icon name="angle-bottom" class="icon-top"/></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data: () => ({
    scrollListener: undefined,
    canShowScrollTop: false,
  }),
  computed: {
    scrollTopVisible() {
      return this.canShowScrollTop;
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener, false);
  },
  mounted() {
    this.scrollListener = window.addEventListener('scroll', this.checkScroll);
  },
  methods: {
    checkScroll: _.debounce(function a() {
      const scrollTop = window.pageYOffset || document.scrollTop || document.body.scrollTop;

      this.canShowScrollTop = scrollTop > 500;
    }, 100),

    scrollToTop() {
      this.canShowScrollTop = false;

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .main {
    margin: 30px auto;
    position: relative;

    .in-gamecenter & {
      margin: 0 auto;
    }
  }

  .scroll-top-button {
    display: block;
    position: fixed;
    z-index: 900;
    bottom: 40px;
    left: 20px;
    padding: 8px 20px;
    text-align: center;
    background-color: $white-three;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .11);
    opacity: 1;
    transition: opacity .6s, z-index .6s;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;

    .scroll-top-text {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: $black-five;
      opacity: .7;
      transition: opacity .1s;
      .icon-top {
        margin-right: 6px;
        transform: rotate(180deg);
      }
    }
    &:hover {
      .scroll-top-text {
        opacity: 1;
      }
    }


    &.hidden {
      opacity: 0;
      z-index: -1;
    }

    [dir=rtl] & {
      right: 20px;
      left: auto;
    }
  }

  .fade-animation {
    &.fade-enter-active, &.fade-leave-active {
      transition: opacity .2s;
    }

    &.fade-enter, &.fade-leave-to {
      opacity: 0;
    }
  }

  .readMode {
    .scroll-top-button {
      display: none;
    }
  }

  .in-gamecenter {
    .pvp-container {
      @include media(max, sm) {
        min-width: auto;
      }
    }
  }
</style>
